import { Typography } from '@mui/material';
import React from 'react';
import Jobs from '../../components/Contractors/Jobs/Jobs';

const ContractorJobs = () => {
    return (
        <div>
            <Typography variant='h1'>Jobs</Typography>
            <Jobs />
        </div>
    );
};

export default ContractorJobs;
